const resources = {
  "en": {
    "activityLog": {
      "title": "Account activity log",
      "description": "Review sign-ins and account-level changes for your workspace.",
      "tableTitle": "Recent activity",
      "tableDescription": "{{count}} events are currently loaded in this view.",
      "loadError": "Unable to load activity log.",
      "empty": "No activity recorded yet.",
      "loading": "Loading activity…",
      "columns": {
        "type": "Type",
        "timestamp": "Timestamp",
        "ipAddress": "IP address",
        "userAgent": "User agent",
        "reason": "Reason"
      },
      "actions": {
        "refresh": "Refresh",
        "loadMore": "Load more"
      },
      "fallbacks": {
        "unknown": "Unknown",
        "notProvided": "Not provided"
      }
    }
  },
  "uk": {
    "activityLog": {
      "title": "Журнал активності облікового запису",
      "description": "Переглядайте входи та зміни на рівні облікового запису у вашому робочому просторі.",
      "tableTitle": "Остання активність",
      "tableDescription": "У цьому вигляді зараз завантажено {{count}} подій.",
      "loadError": "Не вдалося завантажити журнал активності.",
      "empty": "Поки що активність не зафіксована.",
      "loading": "Завантаження активності…",
      "columns": {
        "type": "Тип",
        "timestamp": "Часова позначка",
        "ipAddress": "IP-адреса",
        "userAgent": "Користувацький агент",
        "reason": "Причина"
      },
      "actions": {
        "refresh": "Оновити",
        "loadMore": "Завантажити ще"
      },
      "fallbacks": {
        "unknown": "Невідомо",
        "notProvided": "Не вказано"
      }
    }
  }
};

export default resources;
